module.exports = __webpack_public_path__ + "static/img/bouton-gestion-des-equipes.5001129.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bouton-gestion-des-equipes.png
// module id = 691
// module chunks = 1